import { rem } from 'polished';
import styled, { css } from 'styled-components';
import { breakpoints } from '../../styles/theme';
import { IconTemplate } from '@components/Icon/IconTemplate';


export const Wrapper = styled.div`
    padding: ${rem(10)};
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.3);
    width: 100vw;
    height: 100vh;
    z-index: 999999;
    display: flex;
    align-items: center;
    justify-content: center;
`;


export const Modal = styled.div`
    width: 90%;
    height: 60vh;
    background: white;
    border-radius: ${rem(12)};
    position: relative;
    padding: ${rem(10)};
    @media (min-width: ${breakpoints.sm}px) {
        width: ${rem(600)};
        height: auto;
    }
`;

export const ModalContent = styled.div`
    width: 100%;
    height: 100%;
    padding: ${rem(30)};
    @media (max-width: ${breakpoints.sm}px) {
        top:0;
        left:0;
        position: absolute;
        overflow: scroll;
        scrollbar-width: none;
        padding: ${rem(50)} ${rem(30)} ${rem(30)} ${rem(30)};
    }
`;

export const CloseButton = styled.div`
    background: none;
    border: none;
    cursor: pointer;
    position: absolute;
    right: ${rem(15)};
    top: ${rem(15)};
`;

export const Header = styled.div`

`;

export const Description = styled.p`
    //padding: ${rem(10)} ${rem(40)} ${rem(10)};
    line-height: 1.8;
    font-size: ${rem(16)};
`;

export const DescriptionBold = styled.p`
    //padding: ${rem(10)} ${rem(40)} ${rem(10)};
    line-height: 1.8;
    font-size: ${rem(16)};
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
`;


export const Icon = styled(IconTemplate)`
    margin-right: ${rem(10)};
    cursor: pointer;

    svg {
        width: ${rem(25)};
        margin-top: ${rem(4)};

        path,
        rect,
        
    }
`;


export const ButtonBox = styled.div`
    display: flex;
    justify-content: center;
`;